import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';

export default function Comp() {
    const { t } = useLang('delta_pro_ultra.launch.detail.Circuits');

    return (
        <>
            <div className={styles.comp} id="Circuits">
                <EfSpec />
                <EfSection title={t('title')} />
                <EcoSectionCard
                    theme="black"
                    layout="img-left"
                    title={t('img_title')}
                    desc={t('img_desc')}
                    pc={'https://websiteoss.ecoflow.com/upload/image/1747901568584/Frame%201612707500.jpg'}
                />
            </div>
        </>
    );
}
